import React from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Footer from 'components/Footer';
import ViewContainer from 'components/ViewContainer';
import Header from 'components/Header';
import getFileObject, { checkValidHeader } from 'helpers/read-file';
import XSSTranslate from 'components/XSSTranslate';
import './csr.scss';

const CSR_FILE_NAME = 'csr';
const CSR_FILE_HEADER = ['lang', 'totalDistance', 'earthPerimeter', 'co2Total', 'treeTotal', 'year', 'month', 'day', 'scooters'];
const CSR_CSV_CONFIG = {};

class CSR extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            tw: {},
            en: {},
        };
    }

    componentDidMount() {
        this.fetchCSV();
    }

    checkRequiredValid = (row) => {
        let result = true;
        const keyArray = Object.keys(row);
        const someFieldsAreEmpty = keyArray.some(item => {
            return (row[item] === undefined || row[item] === '');
        })
        if (someFieldsAreEmpty || keyArray.length < 9) {
            result = false;
        }
        return result;
    }

    checkValidFileFormat = (header, rows) => {
        const isValidHeader = checkValidHeader(header, CSR_FILE_HEADER);
        const isRowsValid = item => this.checkRequiredValid(item);
        return !!(isValidHeader && rows.length && rows.every(isRowsValid));
    }

    fetchCSV = async() => {
        await getFileObject(CSR_FILE_NAME, (rows, header) => {
            const isValid = this.checkValidFileFormat(header,rows);
            let result = {};
            if (isValid) {
                rows.forEach( (row, i) => {
                    const lang = rows[i].lang;
                    result[lang] = rows[i];
                });
            }
            return result;
        }, CSR_CSV_CONFIG)
        .then(data => {
            const { tw, en } = data;
            this.setState({
                tw,
                en,
                isLoaded: true,
            });
        });

    }

    render () {
        const { i18n } = this.props;
        const { locale } = i18n;
        const region = (['zh', 'zh-TW'].indexOf(locale) > -1)? 'tw' : 'en';
        const { isLoaded, [region]: CSR  } = this.state;

        return (
            <ViewContainer className="csr">
                <Header show sticky />
                <h2 className="hero">
                    <Translate value="csr.hero-caption-1" tag="p" />
                    <Translate value="csr.hero-caption-2" tag="p" />
                </h2>
                {
                    CSR && isLoaded ? (
                        <div className="container">
                            <section className="saving">
                                <Translate className="subtitle" value="csr.travel-title" tag="h3" />
                                <p className="count unit km" data-unit="km">{ CSR.totalDistance }</p>
                                <Translate className="description" value="csr.travel-description-1" tag="p" count={ CSR.earthPerimeter } />
                                <Translate className="description" value="csr.travel-description-2" tag="p" count={ CSR.earthPerimeter } />
                            </section>
                            <section className="saving">
                                <XSSTranslate className="subtitle" value="csr.saving-title" tag="h3" />
                                <p className="count unit kg" data-unit="kg">{ CSR.co2Total }</p>
                                <Translate className="description" value="csr.saving-description-1" tag="p" count={ CSR.treeTotal } />
                                <Translate className="description" value="csr.saving-description-2" tag="p" count={ CSR.treeTotal } />
                            </section>
                            <Translate
                                className="summary"
                                value="csr.summary"
                                scooters={ CSR.scooters }
                                year={ CSR.year }
                                month={ CSR.month }
                                day={ CSR.day }
                            />
                        </div>
                    ) : null
                }
                <Footer />
            </ViewContainer>
        );
    }
}

export default connect(state => ({ i18n: state.i18n }))(CSR);
